
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mui-x-sep-2024-price-update",
      function () {
        return require("private-next-pages/blog/mui-x-sep-2024-price-update.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/mui-x-sep-2024-price-update"])
      });
    }
  